import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/navigation/Sidebar';
import NavigationBreadcrumb from '../../components/navigation/NavigationBreadcrumb';
import NotificationIndicator from '../../components/navigation/NotificationIndicator';

import Button from '../../components/ui/Button';
import CalendarHeader from './components/CalendarHeader';
import MonthView from './components/MonthView';
import WeekView from './components/WeekView';
import DayView from './components/DayView';

import EventModal from './components/EventModal';



const CalendarScheduling = () => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  const [direction, setDirection] = useState(() => {
    return localStorage.getItem('direction') || 'ltr';
  });

  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState('month');
  const [isEventModalOpen, setIsEventModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    const savedDirection = localStorage.getItem('direction') || 'ltr';
    setLanguage(savedLanguage);
    setDirection(savedDirection);
    document.documentElement?.setAttribute('dir', savedDirection);
  }, []);

  const mockEvents = [
    {
      id: 1,
      title: 'Court Hearing - Case #2024-156',
      titleAr: 'جلسة محكمة - قضية #2024-156',
      type: 'hearing',
      date: '2026-01-28',
      time: '10:00',
      location: 'Tribunal de Première Instance, Casablanca',
      locationAr: 'محكمة الدرجة الأولى، الدار البيضاء',
      participants: 'Ahmed Benali, Client: Hassan Idrissi',
      participantsAr: 'أحمد بنعلي، العميل: حسان الإدريسي',
      caseReference: '2024-156',
      courtroom: 'Salle 3',
      notes: 'Bring all property documents and witness statements'
    },
    {
      id: 2,
      title: 'Client Consultation - Divorce Case',
      titleAr: 'استشارة عميل - قضية طلاق',
      type: 'appointment',
      date: '2026-01-28',
      time: '14:00',
      location: 'Office - Meeting Room A',
      locationAr: 'المكتب - قاعة الاجتماعات أ',
      participants: 'Fatima El Amrani, Client: Amina Bensouda',
      participantsAr: 'فاطمة العمراني، العميلة: أمينة بنسودة'
    },
    {
      id: 3,
      title: 'Document Submission Deadline',
      titleAr: 'الموعد النهائي لتقديم المستندات',
      type: 'deadline',
      date: '2026-01-29',
      time: '17:00',
      location: 'Court Registry',
      locationAr: 'سجل المحكمة',
      notes: 'Submit appeal documents for Case #2024-089'
    },
    {
      id: 4,
      title: 'Team Meeting - Case Review',
      titleAr: 'اجتماع الفريق - مراجعة القضايا',
      type: 'meeting',
      date: '2026-01-30',
      time: '09:00',
      location: 'Conference Room',
      locationAr: 'قاعة المؤتمرات',
      participants: 'All Lawyers'
    },
    {
      id: 5,
      title: 'Court Hearing - Commercial Dispute',
      titleAr: 'جلسة محكمة - نزاع تجاري',
      type: 'hearing',
      date: '2026-01-30',
      time: '11:00',
      location: 'Tribunal de Commerce, Rabat',
      locationAr: 'المحكمة التجارية، الرباط',
      participants: 'Youssef Alaoui',
      caseReference: '2024-203',
      courtroom: 'Salle 7'
    },
    {
      id: 6,
      title: 'New Client Intake',
      titleAr: 'استقبال عميل جديد',
      type: 'appointment',
      date: '2026-01-31',
      time: '15:30',
      location: 'Office',
      locationAr: 'المكتب',
      participants: 'Samira Tazi'
    },
    {
      id: 7,
      title: 'Contract Review Deadline',
      titleAr: 'الموعد النهائي لمراجعة العقد',
      type: 'deadline',
      date: '2026-02-01',
      time: '12:00',
      location: 'Internal',
      locationAr: 'داخلي'
    },
    {
      id: 8,
      title: 'Court Hearing - Labor Dispute',
      titleAr: 'جلسة محكمة - نزاع عمالي',
      type: 'hearing',
      date: '2026-02-03',
      time: '10:30',
      location: 'Tribunal Social, Casablanca',
      locationAr: 'المحكمة الاجتماعية، الدار البيضاء',
      participants: 'Ahmed Benali',
      caseReference: '2024-178',
      courtroom: 'Salle 2'
    },
    {
      id: 9,
      title: 'Client Follow-up Meeting',
      titleAr: 'اجتماع متابعة العميل',
      type: 'appointment',
      date: '2026-02-04',
      time: '16:00',
      location: 'Office',
      locationAr: 'المكتب',
      participants: 'Fatima El Amrani'
    },
    {
      id: 10,
      title: 'Mediation Session',
      titleAr: 'جلسة وساطة',
      type: 'meeting',
      date: '2026-02-05',
      time: '14:00',
      location: 'Mediation Center, Rabat',
      locationAr: 'مركز الوساطة، الرباط',
      participants: 'Youssef Alaoui, Both parties'
    }
  ];

  const handleNavigate = (direction) => {
    const newDate = new Date(currentDate);
    if (view === 'month') {
      newDate?.setMonth(newDate?.getMonth() + (direction === 'next' ? 1 : -1));
    } else if (view === 'week') {
      newDate?.setDate(newDate?.getDate() + (direction === 'next' ? 7 : -7));
    } else {
      newDate?.setDate(newDate?.getDate() + (direction === 'next' ? 1 : -1));
    }
    setCurrentDate(newDate);
  };

  const handleTodayClick = () => {
    setCurrentDate(new Date());
  };

  const handleDateClick = (date) => {
    setCurrentDate(date);
    setView('day');
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setIsEventModalOpen(true);
  };

  const handleCreateEvent = (type = null) => {
    setSelectedEvent(type ? { type } : null);
    setIsEventModalOpen(true);
  };

  const handleSaveEvent = (eventData) => {
    console.log('Saving event:', eventData);
    setIsEventModalOpen(false);
    setSelectedEvent(null);
  };

  const pageTitle = {
    en: 'Calendar & Scheduling',
    fr: 'Calendrier et planification',
    ar: 'التقويم والجدولة'
  };

  const pageDescription = {
    en: 'Manage court hearings, appointments, and deadlines',
    fr: 'Gérer les audiences, rendez-vous et échéances',
    ar: 'إدارة جلسات المحكمة والمواعيد والمواعيد النهائية'
  };

  return (
    <div className="min-h-screen bg-background" style={{ direction }}>
      <Sidebar 
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <div 
        className={`transition-all duration-250 pt-16 lg:pt-0 ${isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-60'}`}
      >
        <header className="sticky top-0 z-40 bg-card border-b border-border shadow-elevation-sm">
          <div className="px-2 sm:px-4 md:px-6 lg:px-8 py-4">
            <div className="flex items-center justify-between gap-4">
              <div className="flex-1 min-w-0">
                <NavigationBreadcrumb language={language} />
                <h1 className="text-2xl md:text-3xl font-bold text-foreground mt-2">
                  {pageTitle?.[language]}
                </h1>
                <p className="text-sm md:text-base text-muted-foreground mt-1">
                  {pageDescription?.[language]}
                </p>
              </div>

              <div className="flex items-center gap-3">
                <NotificationIndicator language={language} />
                <Button
                  variant="default"
                  iconName="Plus"
                  iconPosition="left"
                  onClick={() => handleCreateEvent()}
                  className="hidden sm:flex"
                >
                  {language === 'fr' ? 'Nouvel événement' : language === 'ar' ? 'حدث جديد' : 'New Event'}
                </Button>
                <Button
                  variant="default"
                  size="icon"
                  iconName="Plus"
                  onClick={() => handleCreateEvent()}
                  className="sm:hidden"
                />
              </div>
            </div>
          </div>
        </header>

        <main className="px-2 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 sm:gap-6">
            <div className="lg:col-span-3 space-y-4 sm:space-y-6">
              <CalendarHeader
                currentDate={currentDate}
                view={view}
                onViewChange={setView}
                onNavigate={handleNavigate}
                language={language}
                onTodayClick={handleTodayClick}
              />

              {view === 'month' && (
                <MonthView
                  currentDate={currentDate}
                  events={mockEvents}
                  onDateClick={handleDateClick}
                  onEventClick={handleEventClick}
                  language={language}
                />
              )}

              {view === 'week' && (
                <WeekView
                  currentDate={currentDate}
                  events={mockEvents}
                  onEventClick={handleEventClick}
                  language={language}
                />
              )}

              {view === 'day' && (
                <DayView
                  currentDate={currentDate}
                  events={mockEvents}
                  onEventClick={handleEventClick}
                  language={language}
                />
              )}
            </div>
          </div>
        </main>
      </div>
      <EventModal
        isOpen={isEventModalOpen}
        onClose={() => {
          setIsEventModalOpen(false);
          setSelectedEvent(null);
        }}
        onSave={handleSaveEvent}
        event={selectedEvent}
        language={language}
      />
    </div>
  );
};

export default CalendarScheduling;